export const PRODUCT_URLS = {
  huax: 'https://huax.one',
  // Update this URL if the production Centeo page changes.
  centeo: 'https://www.centeo.one',
};
